// extracted by mini-css-extract-plugin
module.exports = {"rfSafeArea":"safe-area_rfSafeArea__V1ror","rfSafeArea__top":"safe-area_rfSafeArea__top__VIZVt","rfSafeArea__bottom":"safe-area_rfSafeArea__bottom__979au"};